export const enum SearchScope {
    Organisation = "organisation",
    Project = "project",
    Subject = "subject"
}
